import React from "react";

import { useDeviceTesterStateContext } from "../../../device-tester-context-provider/DeviceTesterContextProvider";

import { ResultsDesktopDeviceStatusCard } from "./DesktopDeviceStatusCard";
import { ConnectedResultsDesktopDeviceStatusCardProps } from "./DesktopDeviceStatusCard.types";

export const ConnectedResultsDesktopDeviceStatusCard: React.FC<ConnectedResultsDesktopDeviceStatusCardProps> =
  ({ testResult, deviceName, selectedDevice }) => {
    const { deviceTesterState } = useDeviceTesterStateContext();

    return (
      <ResultsDesktopDeviceStatusCard
        testResult={testResult}
        deviceName={deviceName}
        isInfoFetched={deviceTesterState.isInfoFetched}
        selectedDevice={selectedDevice}
      />
    );
  };
